import './Message.css'
import React, { useState, useEffect } from 'react'
import { MESSAGE_TIMEOUT_MS, MESSAGE_FADE_MS } from '../rules/gameConfig'

export default function Message({ message, setMessage }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (message) {
            setIsVisible(true);
            const timer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    setMessage('');
                }, MESSAGE_FADE_MS);
            }, MESSAGE_TIMEOUT_MS);

            return () => clearTimeout(timer);
        }
    }, [message, setMessage])

    const dismissAlert = () => {
        setIsVisible(false);
        setTimeout(() => {
            setMessage('');
        }, MESSAGE_FADE_MS);
    };

    return (
        message && (
            <div className={`alert ${isVisible ? '' : 'fade-out'}`}>
                <span>{message}</span>
                <button className="dismiss-btn" onClick={dismissAlert}>Dismiss</button>
            </div>
        )
    )
}